import pathToRegexp from 'path-to-regexp';
import { mapState } from 'vuex';
export default {
  data() {
    return {
      levelList: null
    };
  },
  computed: {
    ...mapState({
      sidebar: state => state.app.sidebar
    })
  },
  watch: {
    $route() {
      this.getBreadcrumb();
    }
  },
  created() {
    this.getBreadcrumb();
  },
  methods: {
    getBreadcrumb() {
      // only show routes with meta.title
      let matched = this.$route.matched.filter(item => item.meta && item.meta.title);
      const first = matched[0];
      if (!this.isDashboard(first)) {
        matched = [{
          path: '/dashboard',
          meta: {
            title: '首页'
          }
        }].concat(matched);
      } else {
        matched = [{
          path: '/dashboard',
          meta: {
            title: '首页'
          }
        }];
      }
      if (this.$route.query.parent) {
        matched = matched.concat(JSON.parse(this.$route.query.parent));
      }
      if (this.$route.query.route) {
        matched = matched.concat(JSON.parse(this.$route.query.route));
      }
      this.levelList = matched.filter(item => item.meta && item.meta.title && item.meta.breadcrumb !== false);
    },
    isDashboard(route) {
      const name = route && route.name;
      if (!name) {
        return false;
      }
      return name.trim().toLocaleLowerCase() === 'Dashboard'.toLocaleLowerCase() || route.redirect === '/dashboard';
    },
    pathCompile(path) {
      // To solve this problem https://github.com/PanJiaChen/vue-element-admin/issues/561
      const {
        params
      } = this.$route;
      var toPath = pathToRegexp.compile(path);
      return toPath(params);
    },
    handleLink(item) {
      if (this.$route.query.parent && this.$route.query.route) {
        return;
      }
      const {
        redirect,
        path
      } = item;
      if (redirect) {
        this.$router.push(redirect);
        return;
      }
      this.$router.push(this.pathCompile(path));
    }
  }
};